import { Input, InputProps } from 'antd';
import { TextAreaProps } from 'antd/lib/input';
import classNames from 'classnames';
import inputSearch from '../../assets/svg/search-icon.svg';

import styles from './index.module.scss';

export const CommonSearchInput = (props: InputProps) => {
  return (
    <Input
      {...props}
      className={`${styles.searchInput} ${props.className || ''}`}
      prefix={<img src={inputSearch} className={classNames('icon')} />}
    />
  );
};

export const CommonInput = (props: InputProps & { fullWidth?: boolean }) => {
  return (
    <Input
      {...props}
      className={classNames(styles.commonInput, props.className || '', {
        [styles.fullWidth]: props.fullWidth,
      })}
    />
  );
};

export const CommonTextArea = (props: TextAreaProps) => {
  return (
    <Input.TextArea
      {...props}
      className={`${styles.textarea} ${props.className || ''}`}
    />
  );
};
